<div class="loginPageBackground">
  <div class="header-background" data-test="account-locked-head">
    <span class="header-text">Account Locked</span>
  </div>
  <div class="padding-top-sm center" data-test="account-locked-text">
    <mat-icon class="locked-icon-size" svgIcon="locked"></mat-icon>
    <span class="center-text">Your account has been locked for<br />activity that violates our
      <a [routerLink]="[]" (click)="onNavigateToTermsConditions()">Terms and Conditions</a><br />
      and will be unavailable<br />until further notice.</span>
    <hr />
    <span class="center-text">For details and account revival help,<br />please contact us at<br />
      <a href="mailto:support@fleetoperate.com">driverhelp&#64;fleetoperate.com</a></span>
  </div>

  <div class="padding-top-lg" fxFlex>
    <button class="margin-bottom margin-top-xlg" mat-raised-button type="submit" (click)="onLogout()"
      data-test="logout-button">
      LOG OUT
    </button>
  </div>
</div>